import { DefaultTriggerHandler } from '@leverege/molten/screens';
export default class RsrcTriggerHandler extends DefaultTriggerHandler {
  // preQuery() {
  //   super.preQuery()
  //   const { clientProps : { delegate } } = this.context

  //   GlobalState.dispatch( {
  //     type : Constants.RSRC_STATUS,
  //     ownerId : delegate.resourceApi.id,
  //     coownerId : null,
  //     path : '',
  //     status : 'loading',
  //     queryName : delegate.queryName,
  //   } )
  // }

  postQuery() {}
}